export default __webpack_public_path__ + "static/media/video-img.bdf98ca3.svg";